import { D, G } from "@mobily/ts-belt";

const validActions = new Set(["search-nav", "search-products", "search-shops"]);

export default async function trackSearchEvent({ action, payload }) {
  try {
    if (!validActions.has(action)) {
      throw new Error(`Invalid action: ${action}`);
    }

    if (!G.isObject(payload) || D.isEmpty(payload)) {
      throw new Error(`Invalid payload: ${JSON.stringify(payload)}`);
    }

    const response = await fetch("/api/searchTrackingAction", {
      body: JSON.stringify({ action, payload }),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(
        `Failed to send search tracking action: ${response.statusText}`,
      );
    }
  } catch (err) {
    console.error(err);
  }
}
